// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entryId: __t.u64().primaryKey().name("entry_id"),
  raceId: __t.u64().name("race_id"),
  identity: __t.identity(),
  npc: __t.bool(),
  rival: __t.u8(),
  name: __t.string(),
  state: __t.string(),
  gatesPassed: __t.u16().name("gates_passed"),
  lastGateAt: __t.timestamp().name("last_gate_at"),
  finishMs: __t.u32().name("finish_ms"),
  place: __t.u8(),
  points: __t.u8(),
  updatedAt: __t.timestamp().name("updated_at"),
});
